\<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <!-- <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-text
            label="설치지역"
            name="installLocation"
            v-model="searchParam.installLocation">
          </c-text>
        </div> -->
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 관련공정 -->
          <c-process
            label="LBL0001705"
            multiple="single"
            name="processCd"
            v-model="searchParam.processCd">
          </c-process>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 관리부서 -->
          <c-dept
            type="search"
            label="LBL0001721"
            name="deptCd"
            v-model="searchParam.deptCd">
          </c-dept>
        </div>
      </template>
    </c-search-box>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <!-- 소화설비설치계획 목록 -->
        <c-table
          ref="interlock"
          title="LBL0010500"
          tableId="interlock"
          :columns="grid.columns"
          :gridHeight="grid.height"
          :data="grid.data"
          rowKey="fireEquipmentId"
          :columnSetting="false"
          :expandAll="true"
          @linkClick="linkClick"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <!-- 등록 -->
              <c-btn v-if="editable" label="LBLREG" icon="add" @btnClicked="equipmentPopup" />
              <!-- 검색 -->
              <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';

export default {
  name: 'fire-equipment',

  data() {
    return {
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            // 사업장
            label: 'LBLPLANT',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'revisionNum',
            field: 'revisionNum',
            label: 'Rev.',
            align: 'center',
            style: 'width:50px',
            sortable: true,
          },
          {
            name: 'installLocation',
            field: 'installLocation',
            // 설치지역
            label: 'LBL0010501',
            align: 'center',
            style: 'width:150px',
            type: 'link',
            sortable: true,
          },
          {
            name: 'fireExtinguisher',
            field: 'fireExtinguisher',
            // 소화기
            label: 'LBL0010502',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'autoSpreadFire',
            field: 'autoSpreadFire',
            // 자동확산소화기
            label: 'LBL0010503',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'autoFire',
            field: 'autoFire',
            // 자동소화장치
            label: 'LBL0010504',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'standPipe',
            field: 'standPipe',
            // 옥내소화전
            label: 'LBL0010505',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'sprinkler',
            field: 'sprinkler',
            // 스프링쿨러
            label: 'LBL0010506',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'waterSpray',
            field: 'waterSpray',
            // 물분부소화설비
            label: 'LBL0010507',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'poSpray',
            field: 'poSpray',
            // 포소화설비
            label: 'LBL0010508',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'co2Spray',
            field: 'co2Spray',
            // CO2소화설비
            label: 'LBL0010509',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'halogenSpray',
            field: 'halogenSpray',
            // 할로겐화합물소화설비
            label: 'LBL0010510',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'cleanSpray',
            field: 'cleanSpray',
            // 청정소화약제소화설비
            label: 'LBL0010511',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'outdoorPipe',
            field: 'outdoorPipe',
            // 옥외소화전
            label: 'LBL0010512',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
        ],
        data: [],
      },
      searchParam: {
        plantCd: '',
        installLocation: '',
        processCd: '',
        deptCd: '',
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      // api scope
      this.listUrl = selectConfig.psi.lbe.fireequip.list.url;
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    linkClick(row) {
      this.equipmentPopup(row);
    },
    equipmentPopup(result) {
      this.popupOptions.target = () => import(`${"./firefightingEquipmentInfoDetail.vue"}`);
      this.popupOptions.title = 'LBL0010513'; // 소화설비설치계획 상세
      this.popupOptions.param = {
        fireEquipmentId: result ? result.fireEquipmentId : '',
      };
      this.popupOptions.width = '80%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
